import Vue from "vue";
import { Tree, Button, Cascader } from "element-ui";

Vue.use(Tree)
   .use(Button)
   .use(Cascader)